import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-subsidiary-list-companies',
    templateUrl: './subsidiary-list-companies.component.html',
    styleUrls: ['./subsidiary-list-companies.component.css']
})
export class SubsidiaryListCompaniesComponent implements OnInit {
  sortDir = 1
    constructor() {
    }

    @Input() listAccounts: any = [];
    @Input() showHeadings: boolean = true;
    @Input() showPrimaryColor: boolean = false;
    page = 1;

    ngOnInit(): void {
    }

    setCarrierCodeFocus() {
        $('#myModal').on('shown.bs.modal', function () {
            $('#carrierCode').focus();
        })
    }

    onSortClick(colName, event) {
        let target = event.currentTarget,
            classList = target.classList;
        console.log(classList)
        if (classList.contains('fa-chevron-circle-up')) {

            classList.remove('fa-chevron-circle-up');
            classList.add('fa-chevron-circle-down');
            this.sortDir = -1;
        } else {
            classList.add('fa-chevron-circle-up');
            classList.remove('fa-chevron-circle-down');
            this.sortDir = 1;
        }
        this.sortArr(colName);
    }

    sortArr(colName: any) {
        this.listAccounts.sort((a, b) => {
            a = a[colName].toLowerCase();
            b = b[colName].toLowerCase();
            return a.localeCompare(b) * this.sortDir;
        });
    }

    pager(event) {
        this.page = event;
    }

}
